import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
const AgentLimitPerSite = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://support.atlassian.com${useLocalizedHref(
        "/jira-service-management-cloud/docs/what-are-user-types-and-roles/"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AgentLimitPerSite.header",
            defaultMessage: "Agent limit per site"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.AgentLimitPerSite.body",
            defaultMessage:
                "This is the maximum number of agents or agent licenses you can add to each of your Jira Service Management sites. Agents are licensed users who work on customer requests and add customers to the service project. Agents are added to the Service Desk Team role in your service project."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.AgentLimitPerSite.link",
                defaultMessage:
                    "<learnMore>Learn more</learnMore> about agents in JSM."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default AgentLimitPerSite;
